import { PropsWithChildren } from 'react'

interface StickyProps {
  mode: 'top'
}

export const Sticky = ({ children, mode }: PropsWithChildren<StickyProps>) => <div className={`sticky-${mode}`}>{children}</div>
